// @flow
import PrimaryPalette from '../../colors';
import type { Color } from '../../colors';

type HelpIconStateTheme = {
  backgroundColor: Color,
  borderColor: Color,
  color: Color,
};

type HelpIconTheme = {
  default: HelpIconStateTheme,
  focus: HelpIconStateTheme,
  hover: HelpIconStateTheme,
  active: HelpIconStateTheme,
};

export type TooltipContentTheme = {
  backgroundColor: Color,
  boxShadowColor: string,
  color: Color,
  padding: string,
};

type TooltipThemeSet = {
  default: TooltipContentTheme,
  icon: TooltipContentTheme,
};

type ThemeType = {
  helpIcon: HelpIconTheme,
  tooltip: TooltipThemeSet,
};

const Theme: ThemeType = {
  helpIcon: {
    default: {
      backgroundColor: PrimaryPalette.mediumGrey,
      borderColor: PrimaryPalette.mediumGrey,
      color: PrimaryPalette.mediumEvergreen,
    },
    focus: {
      backgroundColor: PrimaryPalette.mediumGrey,
      borderColor: PrimaryPalette.darkGreen,
      color: PrimaryPalette.mediumEvergreen,
    },
    hover: {
      backgroundColor: PrimaryPalette.darkGrey,
      borderColor: PrimaryPalette.darkGrey,
      color: PrimaryPalette.mediumEvergreen,
    },
    active: {
      backgroundColor: PrimaryPalette.darkerGrey,
      borderColor: PrimaryPalette.darkerGrey,
      color: PrimaryPalette.white,
    },
  },
  tooltip: {
    default: {
      backgroundColor: PrimaryPalette.lightGrey,
      boxShadowColor: PrimaryPalette.mediumEvergreen + '13', // 0.13 alpha
      color: PrimaryPalette.mediumEvergreen,
      padding: '1rem',
    },
    icon: {
      backgroundColor: PrimaryPalette.lightEvergreen,
      boxShadowColor: 'none',
      color: PrimaryPalette.white,
      padding: '0.25rem 0.75rem',
    },
  },
};

export default Theme;
